module.exports = __webpack_public_path__ + "img/man-3.bb0f93ac.svg";